import {IBizAtmosphere, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {AAtmosphere} from "@/views/editor/service/atmosphere/atmosphere";
import {Component, reactive} from "vue";
import {IMusicData, IMusicDataCategory, INotice} from "@/views/editor/service/types";
import CAtmosphereBase from "@/views/editor/service/atmosphere/atmosphere/CAtmosphereBase.vue";


export interface IAtmosphereMeta {
    music_url: string
    virtual: {
        view: number
        sign: number
        share: number
    }
    is_barrage: boolean
    is_statistics: boolean
    is_pay_history: boolean //显示用户报名记录
    is_show_lookers_list: boolean
    auth: {
        cate: 'default' | 'head' | 'custom'
        image: string
    }
    notices: INotice[]
}

export default class Atmosphere extends AAtmosphere implements IBizAtmosphere {

    readonly opt: IAtmosphereMeta
    readonly active = reactive({audio: {playing: false, url: ''}})
    readonly musicLibrary: IMusicData
    readonly audio: HTMLAudioElement

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IAtmosphereMeta

        this.audio = new Audio()
        this.audio.onplay = () => this.active.audio.playing = true
        this.audio.onpause = () => this.active.audio.playing = false
        this.audio.onended = () => this.active.audio.playing = false
        this.musicLibrary = require('@/assets/music/music.json')
    }

    musicName(mUrl: string): string {
        for (const k in this.musicLibrary) {
            for (const item of ((this.musicLibrary as unknown as Record<string, IMusicDataCategory>)[k] as IMusicDataCategory).data) {
                if (item.url == mUrl) return item.name
            }
        }
        return mUrl ? '自定义音乐' : ''
    }

    resetMeta(): IBusiness {
        const opt: IAtmosphereMeta = {
            is_pay_history: false,
            music_url: "",
            is_barrage: true,
            is_statistics: true,
            is_show_lookers_list: true,
            virtual: {share: 0, sign: 0, view: 0},
            auth: {
                cate: 'default',
                image: ''
            },
            notices: []
        }
        Object.assign(this.opt, opt)
        this.initVirtual(Math.round(Math.random() * 101 + 100))
        return this;
    }

    getBaseController(): Component {
        return CAtmosphereBase
    }

    setRules(origin: string, notices: INotice[]): void {
        this.opt.notices = this.opt.notices.filter(n => n.origin != origin)
        this.opt.notices.push(...notices)
    }

    initVirtual(base: number) {
        this.opt.virtual.sign = base
        this.opt.virtual.view = Math.round(this.opt.virtual.sign * 12.32)
        this.opt.virtual.share = Math.round(this.opt.virtual.sign * 2.56)
    }

    clearVirtual() {
        this.opt.virtual.sign = 0
        this.opt.virtual.view = 0
        this.opt.virtual.share = 0
    }
}